<template>
  <B-card>
    <BRow class="items-center justify-content-between pr-2">
      <div
        class="d-flex"
        style="align-items: center;"
      >
        <img
          src="https://storage.googleapis.com/komerce/assets/icons/back.svg"
          alt="Komerce"
          class="cursor-pointer mx-1"
          style="width: 30px;"
          @click="$router.push('/information')"
        >
        <strong class="text-black text-bold text-2xl">Detail Partner</strong>
      </div>
      <BButton
        :variant="isBanned ? 'primary' : 'outline-primary'"
        class="ml-auto d-flex align-items-center"
        @click="openModalPin()"
      >
        <img
          v-if="!isBanned"
          src="https://storage.googleapis.com/komerce/assets/komerce-icon/Orange/danger.svg"
          alt="warning"
          class="mr-[5px] w-[18px]"
        >
        {{ isBanned ? 'Unban Account' : 'Ban Account' }}
        <BSpinner
          v-if="loadingBanned"
          small
          class="ml-[5px]"
        />
      </BButton>
    </BRow>
    <BRow class="mt-[16px] p-[16px] rounded">
      <b-tabs
        v-model="tabIndex"
        content-class="mt-1"
        pills
        nav-class="d-flex align-items-center gap-[16px]"
        active-nav-item-class="shadow-none border-none font-weight-bolder rounded-pill"
        style="width: 100% !important;"
      >
        <b-tab
          title="General"
          lazy
          title-item-class="border border-[#E2E2E2] rounded-pill bg-[#ffffffcc]"
          :active="tabIndex == 0"
        >
          <BOverlay
            :show="loading"
            spinner-variant="primary"
            variant="light"
            blur="0"
            opacity=".5"
            rounded="sm"
          >
            <General
              :user-data="details"
              :is-loading-similarity-account="isLoadingSimilarityAccount"
              :similar-accounts="similarAccounts"
              :is-loading-logs-change="isLoadingLogsChange"
              :logs-changed="logsChanged"
              :finance-menu="financeMenu"
              :modal-value="modalValue"
              @update-user-data="getDetails()"
            />
          </BOverlay>
        </b-tab>
        <b-tab
          title="Komship"
          lazy
          :title-item-class="['border border-[#E2E2E2] rounded-pill bg-[#ffffffcc]', { 'd-none': !isKomshipUser }]"
          :active="tabIndex == 1"
        >
          <BOverlay
            :show="loading"
            spinner-variant="primary"
            variant="light"
            blur="0"
            opacity=".5"
            rounded="sm"
          >
            <Komship :id="details.partner_id" />
          </BOverlay>
        </b-tab>
      </b-tabs>
    </BRow>
    <ModalTOTP
      id="modal-totp-partner-banned"
      ref="modalTotp"
      @submit="banAccount"
    />

    <ModalConfirmBan
      id="modal-confirm-ban"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      @on-click-cancel-button="$bvModal.hide('modal-confirm-ban')"
      @on-click-confirm-button="onConfirmBan"
    />
  </B-card>
</template>

<script>
import {
  BRow,
  BCard,
} from 'bootstrap-vue'
import { mapState } from 'vuex'
import { newAxiosIns } from '@/libs/axios'
import ModalTOTP from '@/views/components/modal/ModalTOTP.vue'
import { handleDefaultResponse } from '@/views/components/modal/modalTOTPUtils'
import ModalConfirmBan from './modalConfirmBan.vue'
import General from './general/General.vue'
import Komship from './komship/Komship.vue'

export default {
  components: {
    BCard,
    BRow,
    General,
    Komship,
    ModalTOTP,
    ModalConfirmBan,
  },
  data() {
    return {
      totpAttempts: 0,
      loading: false,
      tabIndex: 0,
      details: {},
      similarAccounts: {},
      logsChanged: {},
      isLoadingSimilarityAccount: false,
      isLoadingLogsChange: false,
      isBanned: false,
      partnerId: null,
      loadingBanned: false,
      alasanBan: '',
      modalValue: {
        user_id: 0,
        titleModal: '',
        subTitle: '',
        type: '',
        placeholderNotes: '',
        nominal: 0,
        email: '',
        notes: '',
        listEmail: [],
        listLogTransactions: [],
        emailRequired: false,
      },
      financeMenu: {
        topupMenu: false,
        transferSaldo: false,
      },
    }
  },
  computed: {
    ...mapState('menuAdmin', ['listMenu']),

    isKomshipUser() {
      if (!this.details || !Array.isArray(this.details.products)) return false
      return this.details.products.some(p => {
        if (!p || !p.product_name) return false
        const nameMatch = p.product_name.toLowerCase().includes('komship')
        const isActive = p.status === true || p.status === 1 || p.status === 'active'
        return nameMatch && isActive
      })
    },
  },
  mounted() {
    this.getDetails()
    this.getSameAcc()
  },
  methods: {
    async getDetails() {
      try {
        this.loading = true
        const res = await newAxiosIns.get(`/auth/api/v1/admin/partner/information/user/${this.$route.params.id}`)
        this.details = res.data.data
        this.partnerId = res.data.data.partner_id
        this.isBanned = res.data.data.email.endsWith('@')
        this.modalValue.email = this.details.email
        this.modalValue.user_id = this.details.id
      } catch (error) {
        this.$toast_error({ message: 'Gagal Mengambil Detail Partner' })
      } finally {
        this.loading = false
        this.getLogsChanged()
      }
    },
    async getSameAcc() {
      try {
        this.isLoadingSimilarityAccount = true
        const res = await newAxiosIns.get(`/auth/api/v1/admin/user/${this.$route.params.id}/same-account`)
        this.similarAccounts = res.data.data

        const sameBankAccount = this.similarAccounts.same_bank_account ?? []
        const samePhone = this.similarAccounts.same_phone ?? []
        const sameBusinessPhone = this.similarAccounts.same_business_phone ?? []

        this.modalValue.listEmail = Array.from(
          new Map(
            [...sameBankAccount, ...samePhone, ...sameBusinessPhone].map(item => [item.email, item]),
          ).values(),
        ).sort((a, b) => a.email.localeCompare(b.email))
        this.getMenuAdmin()
      } catch (error) {
        this.$toast_error({ message: 'Gagal Mengambil Data Kesamaan Akun' })
      } finally {
        this.isLoadingSimilarityAccount = false
      }
    },
    async getLogsChanged() {
      try {
        this.isLoadingLogsChange = true
        const res = await newAxiosIns.get(`/auth/api/v1/admin/user/${this.$route.params.id}/log-account-change`)
        this.logsChanged = {
          email_log: res.data.data.email_log,
          phone_log: res.data.data.phone_log,
          rekening_log: res.data.data.rekening_log,
        }
      } catch (error) {
        this.$toast_error({ message: 'Gagal Mengambil Log Akun' })
      } finally {
        this.isLoadingLogsChange = false
      }
    },
    openTotpModal() {
      this.totpAttempts = 0
      this.$refs.modalTotp.show({
        title: this.isBanned ? 'Verifikasi Unban Akun' : 'Verifikasi Ban Akun',
        maxAttempts: 3,
        countdownDuration: 2,
      })
    },
    openModalPin() {
      if (this.isBanned) {
        this.openTotpModal()
      } else {
        this.$bvModal.show('modal-confirm-ban')
      }
    },

    onConfirmBan(alasan) {
      this.loadingBanned = true
      this.alasanBan = alasan
      this.$bvModal.hide('modal-confirm-ban')
      this.openTotpModal()
    },
    async banAccount(otpCode, helpers) {
      this.totpAttempts += 1
      if (helpers) helpers.setLoading(true)
      const params = {
        code: otpCode,
        partner_id: parseInt(this.partnerId, 10),
        status: this.isBanned ? 3 : 1,
        notes: this.isBanned ? `Unbanned Account ${this.details.email} by Admin` : this.alasanBan,
      }
      try {
        await newAxiosIns.post('/auth/api/v2/auth/banned-account', params)
        if (this.isBanned) {
          this.$toast_success({ message: 'Status ban untuk akun berhasil dicabut' })
          this.isBanned = false
        } else {
          this.$toast_success({ message: 'Akun berhasil di-ban' })
          this.isBanned = true
        }
        if (helpers) helpers.hide()
        this.totpAttempts = 0
        this.alasanBan = ''
        this.loadingBanned = false
        this.getDetails()
      } catch (error) {
        if (helpers) helpers.setLoading(false)
        this.loadingBanned = false
        const { message, code } = error.response?.data?.meta || {}

        handleDefaultResponse({
          status: code,
          metaMessage: message || 'Gagal memproses request, silakan ulang kembali!',
          helpers,
          totpAttempts: this.totpAttempts,
          toast: this.$toast,
        })
      }
    },
    getMenuAdmin() {
      if (this.listMenu.length > 0) {
        this.financeMenu.topupMenu = this.listMenu.map(item => item.name).includes('Topup')
        if (
          (this.similarAccounts.same_bank_account === null
          && this.similarAccounts.same_phone === null
          && this.similarAccounts.same_business_phone === null)
          || this.details.kmpoin <= 0
        ) {
          this.financeMenu.transferSaldo = true
        }
      }
    },
  },
}
</script>
